module.exports = __webpack_public_path__ + "static/media/EBGaramond-Regular.eb4bef27.ttf";